import React from "react"
import Layout from "../../../components/shared/layout"
import SEO from "../../../components/shared/seo"
import Hero from "./hero"
import Overview from "./overview"
import HowIPSWorks from "./how-IPS-works"
import UseCases from "./use-cases"
import IPStypes from "./IPS-types"
import BottomSection from "./bottom-section"
import BlogFeatures from "./blog-features"
import IndoorPositioningFAQ from "./faq"
import ContactForm from "../../../components/shared/contact"
import Footer from "../../../components/shared/footer"

export default function IndoorPositioningPage({ location }) {
    return (
        <Layout location={location}>
            <SEO 
                title="Indoor Positioning Software"
                description="Indoor positioning software can elevate your indoor mapping experience. Users can view their real-time position within the map and venues can use positioning data and analytics to improve their business."
            />
            <Hero
                title="Indoor Positioning Software"
                description="Indoor positioning software can elevate your indoor mapping experience. Users can view their real-time position within the map and venues can use positioning data and analytics to improve their business."
            />
            <Overview />
            <HowIPSWorks />
            <UseCases />
            <IPStypes />
            <BottomSection />
            <BlogFeatures />
            <IndoorPositioningFAQ />
            <ContactForm />
            <Footer />
        </Layout>
    )
}